import { Link, NavLink } from 'react-router';
import { navigation, site } from '../data/site';
import styles from './SiteHeader.module.scss';

function SiteHeader() {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand}>
          <span className={styles.brandInitials}>{site.initials}</span>
          {/* Decorative rule: a screen reader would otherwise announce
              "vertical line" between the two halves of the wordmark. */}
          <span className={styles.brandDivider} aria-hidden="true" />
          {/* Whitespace-only nodes are ignored by flex layout but still count
              toward the accessible name, which would otherwise run the two
              spans together as "ARAmirhossein Rahmati". */}{' '}
          <span className={styles.brandName}>{site.name}</span>
        </Link>

        {/* Named so screen-reader users can tell this nav from the footer's. */}
        <nav aria-label="Primary">
          <ul className={styles.navList}>
            {navigation.map(({ label, to }) => (
              <li key={to}>
                {/* NavLink sets aria-current="page" on the active route. */}
                <NavLink
                  to={to}
                  end={to === '/'}
                  className={({ isActive }) =>
                    isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
